import { CookieKeys, setHttpOnlyCookie } from '@finn/ui-utils';
import queryString from 'query-string';
import { useEffect } from 'react';

const CLICK_ID_COOKIE_EXPIRY_IN_DAYS = 30;

export const useSetClickIdCookies = () => {
  useEffect(() => {
    const { utm_source, awc, clickid } = queryString.parse(
      window.location.search
    );
    // google, reddit and linkedIn cookies are set automatically with some other script
    // so here we set awin and tisoomi cookies only
    const isAwin = utm_source === 'awin';
    const isTisoomi = utm_source === 'tisoomi';
    if (isAwin && awc) {
      // for ITP proof tracking and to get the benefit of S2S Tracking, we need to set it as httpOnly and secure
      // httpOnly cookie can only be set from the server side
      // ideally we should do it on while serving the html doc but since we use CDN, this is a workaround
      setHttpOnlyCookie(
        CookieKeys.AWIN_CLID,
        awc as string,
        CLICK_ID_COOKIE_EXPIRY_IN_DAYS
      );
    }
    if (isTisoomi && clickid) {
      setHttpOnlyCookie(
        CookieKeys.TISOOMI_CLID,
        clickid as string,
        CLICK_ID_COOKIE_EXPIRY_IN_DAYS
      );
    }
  }, []);
};
